/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 14/09/2025
 */
import {appHelper} from "../../../utils/helpers/appHelper.js";
import auth from "../../../middleware/auth.js";
import shortcuts from "../../../middleware/shortcuts.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";


export const HrAppAttendance = [
    {
        path: appHelper.path.hrApp + '/attendance',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth, shortcuts] },
        children: [
            {
                name: 'hrAppAttendanceLocation',
                path: 'location',
                component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/location/location.vue')),
                meta: { middleware: [auth, shortcuts], termParent: false }
            },
            {
                name: 'hrAppHoliday',
                path: 'holiday',
                component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/holiday/index.vue')),
                meta: { middleware: [auth, shortcuts]}
            },
            {
                name: 'hrAppBreak',
                path: 'break',
                component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/break/index.vue')),
                meta: { middleware: [auth, shortcuts]}
            },
            {
                name: 'hrAppShift',
                path: 'shift',
                component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/shift/index.vue')),
                meta: { middleware: [auth, shortcuts]}
            },
            {
                name: 'hrAppSchedule',
                path: 'schedule',
                component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/schedule/index.vue')),
                meta: { middleware: [auth, shortcuts]}
            }
        ]
    }
]
